import { apiClient } from './client';

/**
 * An Azure AD application the admin still has to grant consent for during
 * sign-up. Mirrors the backend `ConsentApp` DTO returned by the anonymous
 * `GET /api/v2/signUp/consentApps/{invitationId}` endpoint.
 */
export interface ConsentApp {
  id: string;
  name: string;
  /**
   * App logo as a data URI (`data:{mediaType};base64,{data}`), or `null`
   * when the app registration has no logo.
   */
  icon: string | null;
}

/**
 * Fetches the ordered list of Azure AD apps the admin still has to consent
 * to for the given invitation. Anonymous — only the invitation id is known
 * at the start of the flow.
 *
 * The list is fetched **once** at the start of the flow and cached across
 * the consent redirects (see `auth/adminConsent`). The backend prunes
 * already-consented apps for a connected tenant, so re-fetching mid-chain
 * would shrink the list and break the step bookkeeping.
 */
export const fetchConsentApps = async (invitationId: string): Promise<ConsentApp[]> => {
  const response = await apiClient.get<ConsentApp[]>(`/api/v2/signUp/consentApps/${invitationId}`);
  return response.data;
};
